
































import { defineComponent, computed, Ref } from "vue";
import UiButton from "@dpa-id-components/ui-button";
import UiButtonGroup from "@dpa-id-components/ui-button-group";
import "@dpa-id-components/ui-button/dist/UiButton.css";
import "@dpa-id-components/ui-button-group/dist/UiButtonGroup.css";
import useRouter from "@dpa-connect/dpa-id-user/compositions/useRouter";
import router from "@/router";
import useMatomoEvent from "@/composition/useMatomoEvent";

export default defineComponent({
  components: { UiButton, UiButtonGroup },
  setup() {
    const { query } = useRouter(router)();
    const view: Ref<Readonly<String>> = computed(() => {
      return query.value.view;
    });

    const viewOptions = computed(() => [
      {
        text: "Standard",
        value: "long",
        to: {
          query: {
            ...query.value,
            view: "long"
          }
        }
      },
      {
        text: "Kompakt",
        value: "short",
        to: {
          query: {
            ...query.value,
            view: "short"
          }
        }
      }
    ]);

    return { view, viewOptions, useMatomoEvent };
  }
});
